import React from 'react';
import { Button, Flex } from '@chakra-ui/react';
import { Select, SingleValue } from 'chakra-react-select';
import { getChakraReactSelectStyles } from '@udacity/chakra-uds-theme';
import { Option } from 'app/helpers/form-helper';

interface PaginatorProps {
  page: Option<number, number>;
  onPaginate: (page: Option<number, number>) => void;
  options: Option<number, number>[];
}

export const Paginator: React.FC<PaginatorProps> = ({ onPaginate, page, options }) => {
  const handleGoBack = () => {
    onPaginate({ value: page.value - 1, label: page.label - 1 });
  };

  const handleGoForward = () => {
    onPaginate({ value: page.value + 1, label: page.label + 1 });
  };

  const handlePageChange = (option: SingleValue<Option<number, number>>) => {
    if (option) onPaginate(option);
  };

  return (
    <Flex>
      {page.value > 0 && (
        <Button me={4} onClick={handleGoBack}>
          {JSON.stringify('<')}
        </Button>
      )}
      <Select<Option<number, number>>
        chakraStyles={getChakraReactSelectStyles()}
        isRequired
        value={page}
        options={options}
        onChange={handlePageChange}
        isClearable={false}
      />
      {page.value < options.length - 1 && (
        <Button ms={4} onClick={handleGoForward}>
          {JSON.stringify('>')}
        </Button>
      )}
    </Flex>
  );
};
